"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toSlug = exports.toCssName = void 0;

var _slugify = _interopRequireDefault(require("slugify"));

var _paramCase = require("param-case");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const toSlug = string => {
  return (0, _slugify.default)(string, {
    replacement: '-',
    trim: true,
    strict: true,
    lower: true,
    locale: 'de'
  });
};

exports.toSlug = toSlug;

const toCssName = string => {
  return (0, _paramCase.paramCase)(string);
};

exports.toCssName = toCssName;